import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';

/**
 * https://redux-toolkit.js.org/rtk-query/usage-with-typescript
 * Type predicate to narrow an unknown error to `FetchBaseQueryError`
 */
export function isFetchBaseQueryError(
  error: unknown,
): error is FetchBaseQueryError {
  return typeof error === 'object' && error !== null && 'status' in error;
}
